<template>
  <div class="page flex-col justify-end" :class="{ 'is-english': isEnglish }">
    <AppHeader />

    <!-- 1. Banner 第一屏大图（版心居中对齐） -->
    <div class="home-banner-wrapper">
      <img
        class="home-banner-img"
        referrerpolicy="no-referrer"
        src="./assets/img/a.jpg"
        alt="Banner"
      />
    </div>

    <!-- 2. 第二部分：河南汇锐（版心居中对齐） -->
    <div class="box_1 flex-col" id="about">
      <!-- 顶部栏目标题：河南汇锐 -->


      <!-- 内容区域：左侧图，右侧文字列表 -->
      <div class="box_3 flex-row justify-between">
        <img
          class="image_2"
          referrerpolicy="no-referrer"
          src="./assets/img/b.jpg"
        />
        <div class="group_3 flex-col">
          <div class="about-heading-box flex-col">
            <div class="about-hiray-img-wrapper">
              <span class="about-hiray-brand">Hiray Industrial Technology</span>
            </div>
            <h2 class="company-title-zh">
              {{
                isEnglish
                  ? 'Henan Hiray Industrial Technology Co., Ltd.'
                  : '河南汇锐工业技术有限公司'
              }}
            </h2>
            <span class="company-title-en">{{ aboutTagline }}</span>
            <span v-if="aboutTaglineSub" class="company-title-sub">{{ aboutTaglineSub }}</span>
          </div>
          <div class="about-p-list flex-col">
            <p
              v-for="(p, index) in aboutParagraphs"
              :key="'ap_' + index"
              class="about-p"
              :class="{ 'is-subhead': isAboutSubhead(p) }"
            >
              {{ p }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 3. 解决方案（按设计：通栏背景 + 居中标题 + 右侧半透明蓝卡） -->
    <section class="home-sol">
      <div class="home-sol-inner">
        <div class="home-sol-heading">
          <h2 class="home-sol-title">{{ isEnglish ? 'Solutions' : '解决方案' }}</h2>
          <div class="home-sol-underline"></div>
        </div>
        <div class="home-sol-card">
          <h3 class="home-sol-card-title">
            {{
              isEnglish
                ? 'Integrated Counter-UAS Solution for Critical Infrastructure'
                : '重点场所反无人机综合防护解决方案'
            }}
          </h3>
          <p class="home-sol-card-desc">{{ solutionDesc }}</p>
          <router-link class="home-sol-link" :to="solutionLink">
            {{ isEnglish ? 'Learn more' : '了解详情' }}&nbsp;&nbsp;&gt;
          </router-link>
        </div>
      </div>
    </section>
    <!-- 4. 反无人机产品 -->
    <div class="group_5 flex-col">
      <div class="box_6 flex-col">
        <div class="text-wrapper_5 flex-row">
          <span class="text_21">{{ isEnglish ? 'Counter-UAS Products' : '反无人机产品' }}</span>
        </div>
        <div class="section_1 flex-row"><div class="group_6 flex-col"></div></div>
        <div class="text-wrapper_6 flex-row">
          <span class="text_22">{{
            isEnglish
              ? '- Detection · Jamming · Interception · Integrated -'
              : '- 侦测 · 干扰 · 拦截 · 侦反一体 -'
          }}</span>
        </div>
        <div class="section_2 flex-row justify-between">
          <div class="block_2 flex-col">
            <img
              class="image_3"
              referrerpolicy="no-referrer"
              :src="productImage(productShowcase[0])"
              :alt="productLabel(productShowcase[0])"
            />
            <div class="group_7 flex-row">
              <div class="text-group_3 flex-col justify-between">
                <span class="text_23 home-prod-title">
                  <span class="home-prod-name">{{ productLabel(productShowcase[0]) }}</span>
                  <span v-if="productShowcase[0].model" class="home-prod-model">{{ productShowcase[0].model }}</span>
                </span>
                <router-link class="home-detail-link text_24" :to="productDetailLink(productShowcase[0])"
                  >{{ isEnglish ? 'View details' : '查看详情' }}</router-link
                >
              </div>
            </div>
          </div>
          <div class="block_3 flex-col">
            <img
              class="image_4"
              referrerpolicy="no-referrer"
              :src="productImage(productShowcase[1])"
              :alt="productLabel(productShowcase[1])"
            />
            <div class="box_7 flex-row">
              <div class="text-group_4 flex-col justify-between">
                <span class="text_25 home-prod-title">
                  <span class="home-prod-name">{{ productLabel(productShowcase[1]) }}</span>
                  <span v-if="productShowcase[1].model" class="home-prod-model">{{ productShowcase[1].model }}</span>
                </span>
                <router-link class="home-detail-link text_26" :to="productDetailLink(productShowcase[1])"
                  >{{ isEnglish ? 'View details' : '查看详情' }}</router-link
                >
              </div>
            </div>
          </div>
          <div class="block_4 flex-col">
            <img
              class="image_5"
              referrerpolicy="no-referrer"
              :src="productImage(productShowcase[2])"
              :alt="productLabel(productShowcase[2])"
            />
            <div class="box_8 flex-row">
              <div class="text-group_5 flex-col justify-between">
                <span class="text_27 home-prod-title">
                  <span class="home-prod-name">{{ productLabel(productShowcase[2]) }}</span>
                  <span v-if="productShowcase[2].model" class="home-prod-model">{{ productShowcase[2].model }}</span>
                </span>
                <router-link class="home-detail-link text_28" :to="productDetailLink(productShowcase[2])"
                  >{{ isEnglish ? 'View details' : '查看详情' }}</router-link
                >
              </div>
            </div>
          </div>
        </div>
        <div class="section_3 flex-row justify-between">
          <div class="box_9 flex-col">
            <img
              class="image_6"
              referrerpolicy="no-referrer"
              :src="productImage(productShowcase[3])"
              :alt="productLabel(productShowcase[3])"
            />
            <div class="box_10 flex-row">
              <div class="text-group_6 flex-col justify-between">
                <span class="text_29 home-prod-title">
                  <span class="home-prod-name">{{ productLabel(productShowcase[3]) }}</span>
                  <span v-if="productShowcase[3].model" class="home-prod-model">{{ productShowcase[3].model }}</span>
                </span>
                <router-link class="home-detail-link text_30" :to="productDetailLink(productShowcase[3])"
                  >{{ isEnglish ? 'View details' : '查看详情' }}</router-link
                >
              </div>
            </div>
          </div>
          <div class="box_11 flex-col">
            <img
              class="image_7"
              referrerpolicy="no-referrer"
              :src="productImage(productShowcase[4])"
              :alt="productLabel(productShowcase[4])"
            />
            <div class="block_5 flex-row">
              <div class="text-group_7 flex-col justify-between">
                <span class="text_31 home-prod-title">
                  <span class="home-prod-name">{{ productLabel(productShowcase[4]) }}</span>
                  <span v-if="productShowcase[4].model" class="home-prod-model">{{ productShowcase[4].model }}</span>
                </span>
                <router-link class="home-detail-link text_32" :to="productDetailLink(productShowcase[4])"
                  >{{ isEnglish ? 'View details' : '查看详情' }}</router-link
                >
              </div>
            </div>
          </div>
          <div class="box_12 flex-col">
            <img
              class="image_8"
              referrerpolicy="no-referrer"
              :src="productImage(productShowcase[5])"
              :alt="productLabel(productShowcase[5])"
            />
            <div class="group_8 flex-row">
              <div class="text-group_8 flex-col justify-between">
                <span class="text_33 home-prod-title">
                  <span class="home-prod-name">{{ productLabel(productShowcase[5]) }}</span>
                  <span v-if="productShowcase[5].model" class="home-prod-model">{{ productShowcase[5].model }}</span>
                </span>
                <router-link class="home-detail-link text_34" :to="productDetailLink(productShowcase[5])"
                  >{{ isEnglish ? 'View details' : '查看详情' }}</router-link
                >
              </div>
            </div>
          </div>
        </div>
        <div class="text-wrapper_7 flex-row">
          <span class="text_35">{{ isEnglish ? '- Product Series -' : '- 产品系列 -' }}</span>
        </div>
        <div class="section_4 flex-row justify-between">
          <div
            v-for="series in seriesShowcase"
            :key="series.cat"
            class="group_9 flex-row home-series-card"
            @click="goSeries(series.cat)"
          >
            <span class="text_37">{{ isEnglish ? series.labelEn : series.label }}</span>
            <div class="image-wrapper_1 flex-col">
              <img
                class="label_1"
                referrerpolicy="no-referrer"
                src="./assets/img/FigmaDDSSlicePNG05658f78e4e2b33961f5561d0b932be3.png"
              />
            </div>
          </div>
        </div>
        <div class="section_5 flex-row">
          <div
            class="text-wrapper_8 flex-col"
            style="cursor: pointer;"
            @click="goSeries('detect')"
          >
            <span class="text_39">{{ isEnglish ? 'View more products' : '查看更多产品' }}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 5. 工程现场 -->
    <div class="group_18 flex-col project-site-home">
      <div
        class="text-wrapper_17 flex-row"
        style="cursor: pointer;"
        @click="$router.push(projectSiteLink)"
      >
        <span class="text_75">{{ isEnglish ? 'Project Site' : '工程现场' }}</span>
      </div>
      <div class="box_20 flex-row"><div class="section_9 flex-col"></div></div>
      <div class="project-site-preview flex-row justify-between">
        <figure
          v-for="(item, idx) in projectSitePreview"
          :key="'ps_' + idx"
          class="project-site-figure"
          @click="$router.push(projectSiteLink)"
        >
          <img
            class="project-site-thumb"
            :src="item.src"
            :alt="isEnglish ? item.labelEn : item.altZh"
            loading="lazy"
          />
          <figcaption v-if="isEnglish" class="project-site-caption">{{ item.labelEn }}</figcaption>
        </figure>
      </div>
    </div>

    <!-- 6. 联系我们 -->
    <div class="group_12 flex-col" id="contact">
      <div class="contact-title-wrapper flex-col align-center justify-center">
        <span class="about-title-text">{{ isEnglish ? 'Contact Us' : '联系我们' }}</span>
        <div class="about-title-line"></div>
      </div>
      <div class="contact-content-box flex-row justify-between">
        <div class="contact-info-card flex-col">
          <h3 class="contact-card-title">{{ isEnglish ? 'Contact Information' : '联系方式' }}</h3>
          <div class="contact-info-list flex-col">
            <div class="contact-item flex-row align-start">
              <div class="contact-icon-circle flex-col align-center justify-center">
                <img class="contact-icon" src="./assets/img/FigmaDDSSlicePNG315443cebf8e2d5fa268926db5f34297.png" :alt="isEnglish ? 'Address' : '地址'" />
              </div>
              <div class="contact-text-group flex-col">
                <span class="contact-label">{{ isEnglish ? 'Address' : '公司地址' }}</span>
                <span class="contact-val">{{
                  isEnglish
                    ? 'Room 029, 7F, No. 257 Boxue Road, Zhengdong New District, Zhengzhou, Henan, China'
                    : '河南省郑州市郑东新区博学路257号7层029号'
                }}</span>
              </div>
            </div>

            <div class="contact-item flex-row align-start">
              <div class="contact-icon-circle flex-col align-center justify-center">
                <img class="contact-icon" src="./assets/img/FigmaDDSSlicePNG0c5fa50fcd692bb0535bfcaf53e5b340.png" :alt="isEnglish ? 'Phone' : '电话'" />
              </div>
              <div class="contact-text-group flex-col">
                <span class="contact-label">{{ isEnglish ? 'Phone' : '联系电话' }}</span>
                <template v-if="isEnglish">
                  <span class="contact-val">Mr.Feng (Overseas Mgr): +86 135 9259 6878</span>
                  <span class="contact-val">WhatsApp: +86 135 9259 6878</span>
                  <span class="contact-val">Tel: +86 371 86058612</span>
                  <span class="contact-val">Mr.Wang (South China Mgr): 134 5408 0666</span>
                  <span class="contact-val">Ms.Zhang (North China Mgr): 186 3866 1817</span>
                </template>
                <template v-else>
                  <span class="contact-val">Tel：0371 8605 8612</span>
                  <span class="contact-val">134 5408 0666&nbsp;&nbsp;王先生 (南区业务经理)</span>
                  <span class="contact-val">186 3866 1817&nbsp;&nbsp;张小姐 (北区业务经理)</span>
                  <span class="contact-val">135 9259 6878&nbsp;&nbsp;冯先生 (海外业务经理)</span>
                </template>
              </div>
            </div>

            <div class="contact-item flex-row align-start">
              <div class="contact-icon-circle flex-col align-center justify-center">
                <img class="contact-icon" src="./assets/img/FigmaDDSSlicePNGda171ff8e90cde63f83ac9db4d6ccb5c.png" :alt="isEnglish ? 'Email' : '邮箱'" />
              </div>
              <div class="contact-text-group flex-col">
                <span class="contact-label">{{ isEnglish ? 'Email' : '电子邮箱' }}</span>
                <span class="contact-val">evanfeng2024@163.com</span>
              </div>
            </div>
          </div>
        </div>

        <div class="contact-form-card flex-col">
          <h3 class="form-card-title">{{ isEnglish ? 'Send a Message' : '发送消息' }}</h3>
          <form class="message-form flex-col" @submit.prevent="submitMessage">
            <div class="form-row-double flex-row justify-between">
              <div class="form-group flex-col">
                <label class="form-label">{{ isEnglish ? 'Name' : '姓名' }} <span class="required-star">*</span></label>
                <input type="text" class="form-input" v-model="messageForm.name" :placeholder="isEnglish ? 'Please enter your name' : '请输入您的姓名'" required />
              </div>
              <div class="form-group flex-col">
                <label class="form-label">{{ isEnglish ? 'Email' : '邮箱' }} <span class="required-star">*</span></label>
                <input type="email" class="form-input" v-model="messageForm.email" :placeholder="isEnglish ? 'Please enter your email' : '请输入您的电子邮箱'" required />
              </div>
            </div>

            <div class="form-group flex-col">
              <label class="form-label">{{ isEnglish ? 'Company' : '公司名称' }}</label>
              <input type="text" class="form-input" v-model="messageForm.company" :placeholder="isEnglish ? 'Please enter your company name' : '请输入您的公司名称'" />
            </div>

            <div class="form-group flex-col">
              <label class="form-label">{{ isEnglish ? 'Message' : '消息内容' }} <span class="required-star">*</span></label>
              <textarea class="form-textarea" v-model="messageForm.message" rows="3" :placeholder="isEnglish ? 'Please enter your inquiry or requirements' : '请输入您想咨询的消息或需求内容'" required></textarea>
            </div>

            <div class="form-group flex-col">
              <label class="form-label">{{ isEnglish ? 'Phone' : '联系电话' }} <span class="required-star">*</span></label>
              <input type="tel" class="form-input" v-model="messageForm.phone" :placeholder="isEnglish ? 'Please enter your phone number' : '请输入您的联系电话'" required />
            </div>

            <button type="submit" class="form-submit-btn">{{ isEnglish ? 'Submit' : '提交' }}</button>
          </form>
        </div>
      </div>
    </div>
    <AppFooter />
  </div>
</template>
<script>
import { PROJECT_SITE_IMAGES } from '@/data/projectSite';
import { emptyContactForm, submitContactMessage } from '@/utils/contactApi';
import { isEnglishRoute, withLang, langLink } from '@/utils/lang';

const defaultProductImg = require('../lanhu_7chanpinliebiao/assets/img/FigmaDDSSlicePNG89bbbef5e0cf9e9d2d061a45a5ca017b.png');

const ABOUT_ZH = [
  '河南汇锐工业技术有限公司 Hiray Industrial Technology 是一家专注于高端装备研发、生产、销售及技术服务的高新技术企业。公司专注低空安全（反无人机）核心领域，拥有雄厚的技术研发实力、完善的生产体系以及丰富的项目实施经验，可为客户提供专业化技术支持与定制化解决方案。',
  '在低空安全领域，公司依托自主研发和系统集成能力，打造覆盖探测、识别、跟踪、预警及处置的反无人机综合解决方案，为城市安全、机场、油田、化工园区、电力设施、重要活动保障及关键基础设施提供可靠的低空防护体系，助力构建安全、高效的低空管理环境。',
  '汇锐工业始终坚持“技术创新驱动发展，专业服务创造价值”的经营理念，以客户需求为导向，以持续创新为动力，不断推动先进工业技术与智能安全技术的融合发展，为全球客户提供更加高效、可靠、专业的产品与解决方案。'
];

const ABOUT_EN = [
  'Hiray Industrial Technology is a high-tech enterprise specializing in the R&D, manufacturing, sales and technical services of high-end equipment. We focus on Low-Altitude Security & Counter-UAS Solutions. Backed by robust R&D capabilities, mature manufacturing workflows and extensive project delivery experience, we deliver professional technical assistance and customized solutions for global clients.',
  'Low-Altitude Security Solutions Provider',
  'With independent research achievements and professional system integration strengths, we develop comprehensive Low-Altitude C-UAS solutions integrating detection, identification, tracking, early warning and interception modules. Our systematic low-altitude defense solutions are applied to urban public security, airports, oil fields, chemical industrial parks, power utilities, major event protection and critical infrastructure protection, contributing to a secure and orderly low-altitude airspace management ecosystem.',
  'Corporate Philosophy',
  'Guided by the management tenet “Technology innovation fuels development, professional services create value”, HIRAY centers on customer demands and sustainable technological innovation. We keep promoting the integrated evolution of advanced industrial technologies and intelligent security technologies, to supply efficient, dependable and premium products and systematic solutions for worldwide customers.'
];

const ABOUT_TAGLINE_ZH = '反无人机解决方案供应商';
const ABOUT_TAGLINE_EN = 'Low-Altitude Security Solutions Provider';
const ABOUT_TAGLINE_SUB_EN = 'Counter-UAS  Detection ● Identification ● Tracking ● Countermeasure';

/** 首页反无人机产品展示项 */
const PRODUCT_SHOWCASE = [
  { id: 'handheld-detect', label: '手持式感知侦测设备', labelEn: 'Handheld Detection Device', model: 'HR-DH03', cat: 'detect' },
  { id: 'fixed-detect', label: '固定式感知侦测设备', labelEn: 'Fixed Detection Device', model: 'HR-DF09', cat: 'detect' },
  { id: 'radar', label: '低空监视雷达', labelEn: 'Low-Altitude Surveillance Radar', model: 'HR-RD12', cat: 'detect' },
  { id: 'manpack-jam', label: '单兵式干扰设备', labelEn: 'Man-Portable Jamming Device', model: 'HR-JM01', cat: 'jamming' },
  { id: 'net-capture', label: '单兵式物理拦截设备', labelEn: 'Man-Portable Physical Interception Device', model: 'HR-PM11', cat: 'intercept' },
  { id: 'manpack-integrated', label: '单兵式侦反一体设备', labelEn: 'Man-Portable Integrated Detection & Countermeasure Device', model: 'HR-IM02', cat: 'integrated' }
];

const SERIES_SHOWCASE = [
  { cat: 'detect', label: '侦测系列', labelEn: 'Detection Series' },
  { cat: 'jamming', label: '干扰系列', labelEn: 'Jamming Series' },
  { cat: 'integrated', label: '侦反一体系列', labelEn: 'Integrated Detection & Countermeasure' }
];

export default {
  data() {
    return {
      constants: {},
      messageForm: emptyContactForm(),
      projectSitePreview: PROJECT_SITE_IMAGES,
      productShowcase: PRODUCT_SHOWCASE,
      seriesShowcase: SERIES_SHOWCASE,
      productImageMap: {},
      defaultDetailPath: '/products/integrated-system',
      defaultProductImg
    };
  },
  computed: {
    isEnglish() {
      return isEnglishRoute(this.$route);
    },
    aboutParagraphs() {
      return this.isEnglish ? ABOUT_EN : ABOUT_ZH;
    },
    aboutTagline() {
      return this.isEnglish ? ABOUT_TAGLINE_EN : ABOUT_TAGLINE_ZH;
    },
    aboutTaglineSub() {
      return this.isEnglish ? ABOUT_TAGLINE_SUB_EN : '';
    },
    solutionDesc() {
      return this.isEnglish
        ? 'A zoned, layered and graded Counter-UAS solution for refineries, petrochemical parks, power plants and oil & gas facilities—covering multi-source detection, intelligent fusion, graded response and C2 linkage.'
        : '面向炼油厂、化工园区、电厂、油气设施等重点场所，构建分区·分层·分级的反无人机综合防护体系，覆盖多源探测、智能融合、分级处置与平台联动，实现发现得早、识别得准、跟踪得住、处置得当。';
    },
    platformLink() {
      return langLink('/solutions/c-uas', {}, this.$route);
    },
    solutionLink() {
      if (this.isEnglish) {
        return { path: '/solutions/c-uas-en', query: { lang: 'en' } };
      }
      return '/solutions/c-uas-zh';
    },
    projectSiteLink() {
      return langLink('/projects', {}, this.$route);
    }
  },
  created() {
    this.fetchProducts();
  },
  mounted() {
    this.scrollToPageHash();
  },
  watch: {
    '$route.hash'() {
      this.scrollToPageHash();
    }
  },
  methods: {
    isAboutSubhead(text) {
      if (!text || typeof text !== 'string') return false;
      const t = text.trim();
      return (
        t === 'Low-Altitude Security Solutions Provider' ||
        t === 'Corporate Philosophy'
      );
    },
    scrollToPageHash() {
      const hash = this.$route.hash;
      if (!hash) return;
      const id = hash.replace('#', '');
      if (!id) return;
      this.$nextTick(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    },
    productLabel(item) {
      if (!item) return '';
      return this.isEnglish ? item.labelEn || item.label : item.label;
    },
    productImage(item) {
      if (!item) return this.defaultProductImg;
      return this.productImageMap[item.id] || item.image || this.defaultProductImg;
    },
    productDetailLink(item) {
      if (!item) return langLink(this.defaultDetailPath, {}, this.$route);
      return {
        path: item.path || this.defaultDetailPath,
        query: withLang(
          {
            id: item.id || '',
            cat: item.cat || 'detect'
          },
          this.$route
        )
      };
    },
    goSeries(cat) {
      this.$router.push({
        path: '/products',
        query: withLang({ cat }, this.$route)
      });
    },
    async fetchProducts() {
      try {
        const res = await fetch('/data/antidrone.json');
        if (!res.ok) return;
        const data = await res.json();
        const map = {};
        (data.categories || []).forEach((cat) => {
          (cat.products || []).forEach((p) => {
            if (p.id && p.image) map[p.id] = p.image;
          });
        });
        this.productImageMap = map;
      } catch (e) {
        console.warn('Failed to fetch antidrone.json:', e);
      }
    },
    async submitMessage() {
      if (!this.messageForm.name || !this.messageForm.phone || !this.messageForm.message) {
        alert(
          this.isEnglish
            ? 'Please fill in your name, phone number, and message.'
            : '请填写姓名、联系电话和消息内容！'
        );
        return;
      }
      const result = await submitContactMessage(this.messageForm);
      const fallbackOk = this.isEnglish ? 'Submitted successfully!' : '提交完成！';
      const fallbackFail = this.isEnglish
        ? 'Submission failed. Please try again later.'
        : '提交失败，请稍后重试。';
      let msg = result.message || (result.ok ? fallbackOk : fallbackFail);
      if (this.isEnglish) {
        if (result.ok && (!msg || /提交|完成|成功/.test(msg))) msg = fallbackOk;
        else if (!result.ok && (!msg || /失败|空|不能/.test(msg))) msg = fallbackFail;
      }
      alert(msg);
      if (result.ok) {
        this.messageForm = emptyContactForm();
      }
    }
  }
};
</script>
<style scoped>
@import "./assets/index.css";

/* ==========================================================================
   首页统一版心规范：6 大区块内容左缘对齐（1550px / 92%，与 Header 同一条竖线）
   ========================================================================== */

.page {
  width: 100% !important;
  max-width: 1920px !important;
  margin: 0 auto !important;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* 通栏背景区块内的版心容器统一左缘 */
#about.box_1,
.home-sol-inner,
.group_5 .box_6,
.group_12 {
  width: 1550px !important;
  max-width: 92% !important;
  margin-left: auto !important;
  margin-right: auto !important;
  box-sizing: border-box !important;
}

/* 1. 首页 Banner 第一屏大图（通栏满宽 100%，与解决方案背景图同宽） */
.home-banner-wrapper {
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
  box-sizing: border-box;
  overflow: hidden;
}

.home-banner-img {
  width: 100% !important;
  height: 780px !important;
  object-fit: cover;
  object-position: center top;
  display: block;
  border-radius: 0 !important;
}

/* 2. 第二部分：“河南汇锐” */
#about.box_1 {
  background-color: #ffffff;
  position: relative !important;
  left: auto !important;
  top: auto !important;
  width: 1550px !important;
  max-width: 92% !important;
  margin: 0 auto 60px auto !important;
  height: auto !important;
  min-height: auto !important;
  padding: 20px 0 !important;
  box-sizing: border-box;
}

.about-title-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.about-title-text {
  font-size: 38px;
  line-height: 1;
  font-weight: 900;
  font-family: "PingFang SC-Heavy", "PingFang SC", sans-serif;
  color: #000000;
  letter-spacing: 1px;
}

.about-title-line {
  width: 64px;
  height: 3.5px;
  background-color: #1e40af;
  margin-top: 12px;
  border-radius: 1px;
}

.box_3 {
  width: 100% !important;
  max-width: 100% !important;
  margin: 40px 0 0 0 !important;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 50px;
  height: auto !important;
  min-height: 0 !important;
  overflow: visible !important;
}

.image_2 {
  width: 688px !important;
  max-width: 44% !important;
  height: 520px !important;
  margin: 0 !important;
  object-fit: cover;
  flex-shrink: 0;
  border-radius: 2px;
}

.group_3 {
  flex: 1;
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  width: auto !important;
  min-width: 0 !important;
  max-width: 100% !important;
  height: auto !important;
  overflow: visible !important;
}

.about-heading-box {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  min-width: 0;
}

.about-hiray-img-wrapper {
  margin-bottom: 12px;
  display: flex;
  align-items: flex-start;
}

.about-hiray-brand {
  display: inline-block;
  font-size: 28px;
  font-weight: 800;
  line-height: 1.25;
  color: #1e40af;
  letter-spacing: 0.02em;
  font-family: "Segoe UI", "Helvetica Neue", Arial, "PingFang SC", sans-serif;
}

.page.is-english .about-hiray-brand {
  font-size: 26px;
}

.company-title-zh {
  font-size: 32px;
  line-height: 1.25;
  font-weight: 900;
  font-family: "PingFang SC-Heavy", "PingFang SC", sans-serif;
  color: #1e40af;
  margin: 4px 0 6px 0;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.company-title-en {
  font-size: 14px;
  line-height: 1.3;
  font-weight: 600;
  font-family: "PingFang SC-Medium", "PingFang SC", sans-serif;
  color: #1e40af;
  margin-bottom: 8px;
  word-break: break-word;
}

.company-title-sub {
  display: block;
  font-size: 13px;
  line-height: 1.5;
  font-weight: 500;
  color: #64748b;
  margin: -2px 0 10px;
  font-family: "Segoe UI", "Helvetica Neue", Arial, "PingFang SC", sans-serif;
  letter-spacing: 0.02em;
  word-break: break-word;
  white-space: normal;
}

.about-p-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
  overflow: visible;
}

.about-p {
  font-size: 14px;
  line-height: 1.85;
  color: #333333;
  font-family: "PingFang SC-Regular", "PingFang SC", sans-serif;
  margin: 0;
  text-indent: 2em;
  text-align: justify;
  letter-spacing: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
}

.about-p.is-subhead {
  text-indent: 0;
  font-weight: 700;
  color: #1e40af;
  font-size: 15px;
  line-height: 1.5;
  margin-top: 4px;
}

/* 英文简介更长：收紧字号/行距，避免溢出版心 */
.page.is-english #about.box_1 {
  padding-bottom: 36px !important;
}

.page.is-english .company-title-zh {
  font-size: 24px;
  line-height: 1.35;
}

.page.is-english .company-title-en {
  font-size: 13px;
  line-height: 1.45;
}

.page.is-english .company-title-sub {
  font-size: 12px;
  line-height: 1.45;
}

.page.is-english .about-p-list {
  gap: 12px;
}

.page.is-english .about-p {
  font-size: 13px;
  line-height: 1.7;
  text-indent: 0;
}

.page.is-english .about-p.is-subhead {
  font-size: 14px;
  margin-top: 2px;
}

.page.is-english .image_2 {
  height: auto !important;
  max-height: 560px;
  align-self: flex-start;
}

@media (max-width: 1100px) {
  .box_3 {
    flex-direction: column;
    gap: 28px;
  }

  .image_2 {
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    max-height: 420px;
  }
}

/* 3. 第三部分：解决方案（浅色背景，保证前景信息可读） */
.home-sol {
  width: 100%;
  margin: 0;
  padding: 100px 0 120px;
  box-sizing: border-box;
  background: url(/images/c.97bbaffa.jpg) center center / cover no-repeat;
  position: relative;
}

.home-sol::before {
  content: '';
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.58);
  pointer-events: none;
}

.home-sol-inner {
  width: 1550px;
  max-width: 92%;
  margin: 0 auto;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 1;
}

.home-sol-heading {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.home-sol-title {
  margin: 0;
  padding: 0;
  color: #1e40af;
  font-size: 40px;
  font-weight: 900;
  line-height: 1.2;
  font-family: "PingFang SC-Heavy", "PingFang SC", "Microsoft YaHei", sans-serif;
  letter-spacing: 2px;
}

.home-sol-underline {
  width: 129px;
  height: 6px;
  margin-top: 12px;
  background-color: #93c5fd;
}

.home-sol-card {
  width: 933px;
  max-width: 100%;
  margin: 72px 0 0 auto;
  padding: 72px 80px 64px;
  box-sizing: border-box;
  background-color: rgba(255, 255, 255, 0.92);
  border: 1px solid #dbeafe;
  box-shadow: 0 8px 24px rgba(30, 64, 175, 0.08);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.home-sol-card-title {
  margin: 0;
  color: #1e40af;
  font-size: 32px;
  font-weight: 700;
  line-height: 1.4;
  font-family: "PingFang SC-Medium", "PingFang SC", "Microsoft YaHei", sans-serif;
}

.home-sol-card-desc {
  margin: 20px 0 0;
  color: #475569;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.75;
  font-family: "PingFang SC-Medium", "PingFang SC", "Microsoft YaHei", sans-serif;
  text-align: left;
}

.home-sol-link {
  margin-top: 48px;
  color: #1e40af;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  text-decoration: none;
  font-family: "PingFang SC-Medium", "PingFang SC", "Microsoft YaHei", sans-serif;
  transition: color 0.2s ease;
}

.home-sol-link:hover {
  color: #2563eb;
}

@media (max-width: 1100px) {
  .home-sol {
    padding: 72px 0 80px;
  }

  .home-sol-card {
    margin-top: 48px;
    margin-left: 0;
    margin-right: 0;
    padding: 48px 40px 40px;
  }

  .home-sol-card-title {
    font-size: 26px;
  }

  .home-sol-title {
    font-size: 32px;
  }
}

/* 4. 第四部分：反无人机产品 */
.group_5 {
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  padding: 50px 0 30px 0 !important;
  background: url(./assets/img/FigmaDDSSlicePNGb1441abcb7aeec47d6225dd93402bd27.jpg) center center / cover no-repeat !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  box-sizing: border-box !important;
}

.home-prod-title {
  display: flex !important;
  flex-wrap: wrap !important;
  align-items: baseline !important;
  gap: 8px 12px !important;
  width: auto !important;
  height: auto !important;
  max-width: 100% !important;
  white-space: normal !important;
  line-height: 1.4 !important;
  margin: 0 !important;
}

.home-prod-name {
  font-size: 16px !important;
  font-weight: 700 !important;
  color: #0f172a !important;
  line-height: 1.4 !important;
  font-family: "PingFang SC", "Microsoft YaHei", sans-serif !important;
  max-width: 100% !important;
  white-space: normal !important;
  overflow-wrap: break-word !important;
  word-break: break-word !important;
}

.page.is-english .home-prod-name {
  font-size: 13px !important;
  line-height: 1.35 !important;
  letter-spacing: 0.01em;
}

.page.is-english .home-prod-model {
  margin-top: 4px !important;
}

.home-prod-model {
  font-size: 13px !important;
  font-weight: 600 !important;
  line-height: 1.4 !important;
  color: #2563eb !important;
  letter-spacing: 0.04em !important;
  font-family: "Segoe UI", "Helvetica Neue", Arial, "PingFang SC", sans-serif !important;
  background: #eff6ff !important;
  border: 1px solid #bfdbfe !important;
  border-radius: 4px !important;
  padding: 1px 8px !important;
  white-space: nowrap !important;
  flex-shrink: 0 !important;
}

.text_23,
.text_25,
.text_27,
.text_29,
.text_31,
.text_33 {
  width: auto !important;
  height: auto !important;
  overflow: visible !important;
  white-space: normal !important;
}

.text-group_3,
.text-group_4,
.text-group_5,
.text-group_6,
.text-group_7,
.text-group_8 {
  width: 100% !important;
  height: auto !important;
  max-width: 100% !important;
  margin: 0 !important;
  gap: 10px !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
}

.home-detail-link {
  color: inherit !important;
  text-decoration: none !important;
  cursor: pointer !important;
}

.home-detail-link:hover {
  opacity: 0.85;
  text-decoration: underline !important;
}

.box_6 {
  width: 1550px !important;
  max-width: 92% !important;
  margin: 0 auto !important;
  height: auto !important;
  background: none !important;
  padding: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  box-sizing: border-box !important;
}

.text-wrapper_5 {
  width: 100% !important;
  margin: 0 auto !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.text_21 {
  width: auto !important;
  text-align: center !important;
  font-size: 40px !important;
  font-weight: 900 !important;
  color: #000000 !important;
  line-height: 1 !important;
}

.section_1 {
  width: 129px !important;
  height: 6px !important;
  margin: 12px auto 0 auto !important;
  display: flex !important;
  justify-content: center !important;
}

.group_6 {
  width: 129px !important;
  height: 6px !important;
  background-color: rgba(30, 64, 175, 0.4) !important;
}

.text-wrapper_6 {
  width: 100% !important;
  margin: 30px auto 0 auto !important;
  display: flex !important;
  justify-content: center !important;
}

.text_22 {
  width: auto !important;
  text-align: center !important;
  font-size: 28px !important;
  color: #1e40af !important;
  font-weight: 700 !important;
  line-height: 1 !important;
}

.section_2,
.section_3 {
  width: 100% !important;
  margin: 30px 0 0 0 !important;
  display: flex !important;
  flex-direction: row !important;
  justify-content: space-between !important;
  align-items: center !important;
  gap: 30px !important;
  height: auto !important;
}

.block_2,
.block_3,
.block_4,
.box_9,
.box_11,
.box_12 {
  width: calc(33.333% - 20px) !important;
  flex: 1 1 calc(33.333% - 20px) !important;
  min-width: 0 !important;
  height: auto !important;
  min-height: 414px !important;
  background: #ffffff !important;
  border-radius: 9px !important;
  box-shadow: 0px 2px 13px 0px rgba(0, 0, 0, 0.08) !important;
  margin: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: flex-start !important;
  padding: 30px 16px 16px 16px !important;
  box-sizing: border-box !important;
  overflow: hidden !important;
}

.image_3,
.image_4,
.image_5,
.image_6,
.image_7,
.image_8 {
  max-width: 88% !important;
  width: auto !important;
  height: 240px !important;
  object-fit: contain !important;
  margin: 0 auto !important;
  margin-left: auto !important;
  background: #f8fafc !important;
  border-radius: 6px !important;
  flex-shrink: 0 !important;
}

.page.is-english .image_3,
.page.is-english .image_4,
.page.is-english .image_5,
.page.is-english .image_6,
.page.is-english .image_7,
.page.is-english .image_8 {
  height: 220px !important;
}

.group_7,
.box_7,
.box_8,
.box_10,
.block_5,
.group_8 {
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
  padding: 12px 10px 14px !important;
  box-sizing: border-box !important;
  height: auto !important;
  min-height: 0 !important;
  align-self: stretch !important;
  flex-shrink: 0 !important;
}

.text-wrapper_7 {
  width: 100% !important;
  margin: 50px auto 0 auto !important;
  display: flex !important;
  justify-content: center !important;
}

.text_24,
.text_26,
.text_28,
.text_30,
.text_32,
.text_34 {
  width: auto !important;
  height: auto !important;
  margin: 10px 0 0 0 !important;
}

.text_35 {
  width: auto !important;
  text-align: center !important;
  font-size: 28px !important;
  color: #1e40af !important;
  font-weight: 700 !important;
  color: #000000 !important;
}

.section_4 {
  width: 100% !important;
  margin: 30px 0 0 0 !important;
  display: flex !important;
  flex-direction: row !important;
  justify-content: space-between !important;
  align-items: center !important;
  gap: 30px !important;
}

.group_9,
.group_10,
.group_11 {
  width: calc(33.333% - 20px) !important;
  flex: 1 !important;
  height: 80px !important;
  background: #ffffff !important;
  border-radius: 4px !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: space-between !important;
  padding: 0 28px !important;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1) !important;
  margin: 0 !important;
  box-sizing: border-box !important;
}

.home-series-card {
  cursor: pointer;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
}

.home-series-card:hover {
  box-shadow: 0px 0px 10px 0px rgba(18, 162, 223, 0.25) !important;
  transform: translateY(-2px);
}

.text_36,
.text_37,
.text_38 {
  margin: 0 !important;
  font-size: 20px !important;
  font-weight: 900 !important;
  color: #1f2937 !important;
  font-family: "PingFang SC-Heavy", "PingFang SC", sans-serif !important;
  line-height: 1 !important;
  display: inline-flex !important;
  align-items: center !important;
}

.image-wrapper_1,
.image-wrapper_2,
.image-wrapper_3 {
  width: 34px !important;
  height: 34px !important;
  background-color: #1e40af !important;
  border-radius: 2px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin: 0 !important;
}

.label_1,
.label_2,
.label_3 {
  width: 20px !important;
  height: 20px !important;
  margin: 0 !important;
  object-fit: contain !important;
}

.section_5 {
  width: 100% !important;
  max-width: 100% !important;
  height: auto !important;
  margin: 50px auto 0 auto !important;
  left: auto !important;
  top: auto !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  position: relative !important;
}

.text-wrapper_8 {
  width: auto !important;
  max-width: 100% !important;
  min-width: 0 !important;
  margin: 0 auto !important;
  padding: 10px 28px !important;
  height: auto !important;
  min-height: 42px !important;
  border: 2px solid #1e40af !important;
  border-radius: 4px !important;
  background: #ffffff !important;
  cursor: pointer !important;
  display: inline-flex !important;
  flex-direction: row !important;
  justify-content: center !important;
  align-items: center !important;
  box-sizing: border-box !important;
  position: relative !important;
  left: auto !important;
  top: auto !important;
}

.text_39 {
  width: auto !important;
  max-width: 100% !important;
  height: auto !important;
  margin: 0 !important;
  color: #1e40af !important;
  font-size: 16px !important;
  font-weight: 700 !important;
  white-space: nowrap !important;
  line-height: 1.2 !important;
  text-align: center !important;
}

.page.is-english .text-wrapper_8 {
  padding: 10px 24px !important;
}

.page.is-english .text_39 {
  font-size: 15px !important;
  letter-spacing: 0.01em;
}

/* 5. 第五部分：联系我们（覆盖 index.css 里 height:1370px 造成的大片空白） */
.group_12 {
  width: 1550px !important;
  max-width: 92% !important;
  height: auto !important;
  min-height: 0 !important;
  margin: 20px auto 8px auto !important;
  margin-top: 20px !important;
  padding: 0 0 8px 0 !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  position: relative !important;
  background-color: transparent !important;
}

.contact-title-wrapper {
  width: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  margin-bottom: 16px !important;
}

.contact-content-box {
  width: 100% !important;
  display: flex !important;
  flex-direction: row !important;
  justify-content: space-between !important;
  gap: 28px !important;
  align-items: stretch !important;
}

/* 左侧联系方式卡片 */
.contact-info-card {
  width: 380px !important;
  background-color: #f0f5ff !important;
  border-radius: 8px !important;
  padding: 24px 22px !important;
  box-sizing: border-box !important;
  display: flex !important;
  flex-direction: column !important;
}

.contact-card-title {
  font-size: 18px !important;
  font-weight: 900 !important;
  color: #111827 !important;
  margin: 0 0 18px 0 !important;
}

.contact-info-list {
  display: flex !important;
  flex-direction: column !important;
  gap: 18px !important;
}

.contact-item {
  display: flex !important;
  flex-direction: row !important;
  align-items: flex-start !important;
  gap: 12px !important;
}

.contact-icon-circle {
  width: 36px !important;
  height: 36px !important;
  border-radius: 50% !important;
  background-color: #ffffff !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  box-shadow: 0 2px 8px rgba(30, 64, 175, 0.08) !important;
  flex-shrink: 0 !important;
}

.contact-icon {
  width: 18px !important;
  height: 18px !important;
  object-fit: contain !important;
}

.contact-text-group {
  display: flex !important;
  flex-direction: column !important;
  gap: 4px !important;
  flex: 1 1 auto !important;
  min-width: 0 !important;
  max-width: 100% !important;
}

.contact-label {
  font-size: 14px !important;
  font-weight: 900 !important;
  color: #1f2937 !important;
}

.contact-val {
  font-size: 13px !important;
  color: #4b5563 !important;
  line-height: 1.5 !important;
  white-space: normal !important;
  overflow-wrap: break-word !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* 右侧发送消息表单 */
.contact-form-card {
  flex: 1 !important;
  background-color: #ffffff !important;
  border-radius: 8px !important;
  padding: 24px 28px !important;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05) !important;
  border: 1px solid #f1f5f9 !important;
  box-sizing: border-box !important;
}

.form-card-title {
  font-size: 18px !important;
  font-weight: 900 !important;
  color: #111827 !important;
  margin: 0 0 16px 0 !important;
}

.message-form {
  display: flex !important;
  flex-direction: column !important;
  gap: 14px !important;
}

.form-row-double {
  display: flex !important;
  flex-direction: row !important;
  gap: 16px !important;
}

.form-row-double .form-group {
  flex: 1 !important;
}

.form-group {
  display: flex !important;
  flex-direction: column !important;
  gap: 6px !important;
}

.form-label {
  font-size: 13px !important;
  font-weight: 600 !important;
  color: #374151 !important;
}

.required-star {
  color: #ef4444 !important;
}

.form-input,
.form-textarea {
  width: 100% !important;
  padding: 9px 12px !important;
  border: 1px solid #cbd5e1 !important;
  border-radius: 6px !important;
  font-size: 13px !important;
  color: #1f2937 !important;
  background-color: #ffffff !important;
  outline: none !important;
  box-sizing: border-box !important;
  transition: all 0.2s ease !important;
  font-family: inherit !important;
}

.form-input:focus,
.form-textarea:focus {
  border-color: #1e40af !important;
  box-shadow: 0 0 0 3px rgba(30, 64, 175, 0.1) !important;
}

.form-textarea {
  resize: vertical !important;
  min-height: 72px !important;
}

.form-submit-btn {
  width: 100% !important;
  height: 40px !important;
  background-color: #1e40af !important;
  color: #ffffff !important;
  font-size: 15px !important;
  font-weight: 700 !important;
  border: none !important;
  border-radius: 6px !important;
  cursor: pointer !important;
  margin-top: 4px !important;
  transition: background-color 0.2s ease !important;
}

.form-submit-btn:hover {
  background-color: #1d4ed8 !important;
}

/* 6. 第六部分：新闻模块（通栏底图 + 内部版心） */
.group_18 {
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
  padding: 60px 0 50px !important;
  height: auto !important;
  min-height: 420px !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  box-sizing: border-box !important;
  background-color: #ececec !important;
  background-image: url(./assets/img/FigmaDDSSlicePNGbb5e20497eb3807b55480430e5bdd323.jpg) !important;
  background-position: center center !important;
  background-size: cover !important;
  background-repeat: no-repeat !important;
  position: relative !important;
  left: auto !important;
  top: auto !important;
}

.group_18 > .text-wrapper_17,
.group_18 > .box_20,
.group_18 > .box_21,
.group_18 > .project-site-preview,
.group_18 > .news-dots-wrapper {
  width: 1550px !important;
  max-width: 92% !important;
  box-sizing: border-box !important;
}

.project-site-preview {
  position: relative !important;
  left: auto !important;
  top: auto !important;
  width: 100% !important;
  margin: 40px 0 0 0 !important;
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: wrap !important;
  justify-content: space-between !important;
  gap: 24px !important;
}

.project-site-figure {
  flex: 1 1 calc(25% - 18px) !important;
  min-width: 220px !important;
  max-width: calc(25% - 18px) !important;
  margin: 0 !important;
  padding: 0 !important;
  cursor: pointer !important;
  display: flex !important;
  flex-direction: column !important;
  border-radius: 6px !important;
  overflow: hidden !important;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12) !important;
  transition: transform 0.25s ease, box-shadow 0.25s ease !important;
  background: #ffffff !important;
}

.project-site-figure:hover {
  transform: translateY(-4px) !important;
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.16) !important;
}

.project-site-thumb {
  width: 100% !important;
  max-width: 100% !important;
  height: 180px !important;
  object-fit: cover !important;
  display: block !important;
  border-radius: 0 !important;
  box-shadow: none !important;
}

.project-site-caption {
  margin: 0 !important;
  padding: 8px 10px !important;
  font-size: 13px !important;
  font-weight: 600 !important;
  color: #1e293b !important;
  text-align: center !important;
  line-height: 1.3 !important;
  background: #ffffff !important;
  border-top: 1px solid #e2e8f0 !important;
  font-family: 'Segoe UI', 'Helvetica Neue', Arial, sans-serif !important;
}

.project-site-home .text-wrapper_17 {
  width: auto !important;
  max-width: 100% !important;
  height: auto !important;
  justify-content: center !important;
}

.project-site-home .text_75 {
  width: auto !important;
  height: auto !important;
  max-width: 100% !important;
  white-space: normal !important;
  text-align: center !important;
  margin: 0 auto !important;
  line-height: 1.2 !important;
}

.text_75 {
  margin: 0 auto !important;
  text-align: center !important;
}

.section_9 {
  margin: 12px auto 0 auto !important;
}

.box_21 {
  /* 覆盖其它页面同名 .box_21 的 absolute 定位，避免新闻卡片脱离标题 */
  position: relative !important;
  left: auto !important;
  top: auto !important;
  width: 100% !important;
  height: auto !important;
  margin: 40px 0 0 0 !important;
  display: flex !important;
  flex-direction: row !important;
  justify-content: space-between !important;
  gap: 30px !important;
  border: none !important;
  border-radius: 0 !important;
  background: transparent !important;
}

.box_22 {
  flex: 1 !important;
  width: calc(33.333% - 20px) !important;
  max-width: none !important;
  height: 266px !important;
  margin: 0 !important;
  padding: 32px 28px !important;
  box-sizing: border-box !important;
  display: flex !important;
  flex-direction: column !important;
  position: relative !important;
  left: auto !important;
  top: auto !important;
  background-color: #ffffff !important;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1) !important;
  transition: transform 0.3s ease, box-shadow 0.3s ease !important;
}

.box_22:hover {
  transform: translateY(-6px) !important;
  box-shadow: 0px 10px 24px 0px rgba(0, 0, 0, 0.14) !important;
}

.text_76 {
  width: 100% !important;
  margin: 0 !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.text_77 {
  width: 100% !important;
  margin: 16px 0 0 0 !important;
  flex: 1 1 auto !important;
}

.text-wrapper_18 {
  /* 与标题、摘要左对齐，贴在卡片底部，避免旧 margin 把内容拉开 */
  margin: 24px 0 0 0 !important;
  width: auto !important;
  min-width: 85px !important;
  height: 33px !important;
  padding: 0 12px !important;
  box-sizing: border-box !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  background-color: rgba(30, 64, 175, 1) !important;
  border-radius: 4px !important;
  align-self: flex-start !important;
}

.text-wrapper_18.is-muted {
  background-color: #999999 !important;
}

.text_78 {
  margin: 0 !important;
  width: auto !important;
  height: auto !important;
  line-height: 1 !important;
}

/* 底部新闻跑马灯点图指示器 */
.news-dots-wrapper {
  margin-top: 36px !important;
  margin-bottom: 20px !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 14px !important;
  width: 100% !important;
  position: relative !important;
  z-index: 10 !important;
}

.news-dot-item {
  width: 12px !important;
  height: 12px !important;
  border-radius: 50% !important;
  background-color: #94a3b8 !important;
  cursor: pointer !important;
  transition: all 0.3s ease !important;
  display: inline-block !important;
}

.news-dot-item:hover {
  background-color: #64748b !important;
  transform: scale(1.2) !important;
}

.news-dot-item.active {
  width: 32px !important;
  border-radius: 6px !important;
  background-color: #1e40af !important;
  box-shadow: 0 2px 6px rgba(30, 64, 175, 0.3) !important;
}

/* 跑马灯淡入淡出动画 */
.news-fade-enter-active, .news-fade-leave-active {
  transition: opacity 0.4s ease, transform 0.4s ease !important;
}

.news-fade-enter {
  opacity: 0 !important;
  transform: translateY(10px) !important;
}

.news-fade-leave-to {
  opacity: 0 !important;
  transform: translateY(-10px) !important;
}
</style>